import { atom, getDefaultStore } from "jotai";
import { Collection } from "./types/collection";

const store = getDefaultStore();
export const collectionsAtom = atom<Collection[]>([]);

const get = () => store.get(collectionsAtom);

const set = (collections: Collection[]) => store.set(collectionsAtom, collections);

const add = (collection: Collection) => store.set(collectionsAtom, [...store.get(collectionsAtom), collection]);

const update = (updatedCollection: Collection) =>
{
	const collections = store.get(collectionsAtom);
	store.set(collectionsAtom, collections.map(c => c.id === updatedCollection.id ? updatedCollection : c));
};

const remove = (id: string) =>
{
	store.set(collectionsAtom, store.get(collectionsAtom).filter(c => c.id !== id));
};

const updateMod = (updatedMod: { id: string; }) =>
{
	const collections = store.get(collectionsAtom);
	store.set(collectionsAtom, collections.map(c => ({
		...c,
		mods: c.mods.map(m => m.id === updatedMod.id ? { ...m, ...updatedMod } : m)
	})));
};

const removeMod = (modId: string) =>
{
	const collections = store.get(collectionsAtom);
	store.set(collectionsAtom, collections.map(c => ({
		...c,
		mods: c.mods.filter(m => m.id !== modId)
	})));
};

const hasModInCollection = (modId: string): boolean =>
{
	return store.get(collectionsAtom).some(c => c.mods.some(m => m.id === modId));
};

const clear = () => store.set(collectionsAtom, []);

export const collectionStore = {
	get,
	set,
	add,
	update,
	updateMod,
	removeMod,
	hasModInCollection,
	remove,
	clear,
};
